(function (root, factory) {
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  if (root) root.FlavorSetCore = api;
})(typeof window !== 'undefined' ? window : globalThis, function () {
  'use strict';

  // 混合セットはMAJIDEの袋数、通常セットは先頭の「○袋」を読む。
  // 割引率・価格・同梱するMAJINOBIの数量は選択数にしない。
  function requiredBagCount(label) {
    var normalized = String(label || '').normalize('NFKC').trim();
    var match = normalized.match(/\bMAJIDE\s*([0-9]+)\s*袋/i);
    if (!match) match = normalized.match(/^([0-9]+)\s*袋/);
    if (!match) return 0;
    var count = Number(match[1]);
    return Number.isSafeInteger(count) && count > 0 ? count : 0;
  }

  function sameOrderedValues(left, right) {
    if (left.length !== right.length) return false;
    for (var i = 0; i < left.length; i++) {
      if (left[i] !== right[i]) return false;
    }
    return true;
  }

  function countValues(values) {
    return values.reduce(function (counts, value) {
      counts[value] = (counts[value] || 0) + 1;
      return counts;
    }, {});
  }

  function matchesContext(entry, context) {
    return entry.context === context;
  }

  function sameValueCounts(left, right) {
    if (left.length !== right.length) return false;
    var leftCounts = countValues(left);
    var rightCounts = countValues(right);
    return Object.keys(leftCounts).every(function (name) {
      return leftCounts[name] === rightCounts[name];
    });
  }

  function findVariant(availability, context, flavors) {
    var unorderedMatch = null;
    for (var i = 0; i < availability.length; i++) {
      var entry = availability[i];
      if (!entry.available || !matchesContext(entry, context)) continue;
      var entryFlavors = entry.flavors || [];
      if (sameOrderedValues(entryFlavors, flavors)) return entry;
      if (unorderedMatch === null && sameValueCounts(entryFlavors, flavors)) unorderedMatch = entry;
    }
    return unorderedMatch;
  }

  function canCompleteVariant(availability, context, selectedFlavors) {
    var selectedCounts = countValues(selectedFlavors);

    return availability.some(function (entry) {
      if (!entry.available || !matchesContext(entry, context)) return false;
      var entryFlavors = entry.flavors || [];
      if (selectedFlavors.length > entryFlavors.length) return false;
      var entryCounts = countValues(entryFlavors);
      return Object.keys(selectedCounts).every(function (name) {
        return selectedCounts[name] <= (entryCounts[name] || 0);
      });
    });
  }

  function isSafeFlavorCode(code) {
    return /^[A-Za-z0-9_-]+={0,2}$/.test(code);
  }

  /** スウォッチモード用: コンテキスト×先頭フレーバーで在庫マトリクス行を引く（#96） */
  function findSwatchEntry(availability, context, flavor) {
    if (!flavor) return null;
    for (var i = 0; i < availability.length; i++) {
      var entryFlavors = availability[i].flavors || [];
      if (availability[i].context === context && entryFlavors[0] === flavor) {
        return availability[i];
      }
    }
    return null;
  }

  /**
   * 表示すべきUIを決める（#96）。
   * 数量オプション連動の商品で必要数がちょうど1のときだけ既存スウォッチへ戻し、
   * それ以外（固定袋数・必要数2以上・数値パース不能）はすべてステッパーとする。
   * パース不能(0/NaN)をスウォッチにしないのは、必要数不明のまま
   * 通常購入を許すと内訳なしのセット購入が成立してしまうため。
   */
  function resolveUiMode(contextProvidesRequiredCount, requiredCount) {
    if (contextProvidesRequiredCount === true && requiredCount === 1) return 'swatch';
    return 'stepper';
  }

  return {
    requiredBagCount: requiredBagCount,
    findVariant: findVariant,
    canCompleteVariant: canCompleteVariant,
    isSafeFlavorCode: isSafeFlavorCode,
    resolveUiMode: resolveUiMode,
    findSwatchEntry: findSwatchEntry,
  };
});
